// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"89dd44f4","300":"31d6cfe0","323":"00b78505","679":"31d6cfe0"}[chunkId] + ".chunk.css";
};